/**
 * @export
 * @class Global
 */
import { Blocks } from '../../blocks';
import { BaseModule } from '../../helpers/base_module';
import { TextGrow } from '../../modules/textGrow';

import { Animations } from './animations';
import { Contact } from './contact';
import { Navigation } from './navigation';
import { Polyfills } from './polyfills';
import { QuantitySelectors } from './quantity_selectors';
import { Validation } from './validation';

export class Global extends BaseModule {
    public static id = '*';

    
    /**
     * Creates an instance of Global.
     * 
     * @memberof Global
     */
    constructor() {
        super();

        new Blocks();
        new Contact();
        new Validation();
        new Navigation();
        new Animations();
        new Polyfills();
        new QuantitySelectors();

        Global.growTextareas();
    }


    /**
     * Automatic expanding textareas
     *
     * @private
     * @static
     * @memberof Global
     */
    private static growTextareas() {
        const textareas = $('.js-textgrow textarea');
        textareas.each(({}, textarea) => {
            new TextGrow($(textarea));
        });
    }
}
